import React, { Component } from "react";
import { gsap, MotionPathPlugin } from "gsap/all";
import "styled-components/macro";

import MouseCursor from "./MouseCursor";
// https://github.com/maxwellito/vivus#vivusjs
import clickSparks from "./images/click-sparks.svg";
import ClickSparksAnimated from "./ClickSparksAnimated";
import guessMyDevice from "./utils/guess-my-device";

gsap.registerPlugin(MotionPathPlugin);

export default class BonusFeaturesFullyMouseCapable extends Component {
  initialState = {
    animationStep: 0,
  };
  state = this.initialState;
  timers = [];
  gsapMouseCursor = null;
  animationMs = 250;
  device = guessMyDevice();
  render() {
    const { animationStep } = this.state;
    const padding = 39;

    return (
      <div
        onMouseEnter={this.startAnimation}
        onMouseLeave={this.resetAnimation}
        css={`
          position: relative;
          display: inline-flex;
          margin: 16px 0 0;
          width: ${this.device !== "mobile" ? "33%" : "100%"};
          height: 500px;
          color: white;
          cursor: grab;
          border-radius: 15.0px;
          overflow: hidden;
          background-color: hsl(240 11% 95% / 1);
          box-shadow: 2.5px 2.2px 0px 0.5px hsl(240deg 8% 90%);
          border: 1px solid hsl(0deg 0% 54% / 40%);
          filter: brightness(1.07);
          transition: filter 140ms ease-out;
          &:hover {
            box-shadow: none;
            filter: brightness(1);
          }
        `}
      >
        <div
          css={`
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
          `}
        >
          <div
            css={`
              padding: ${padding}px 0 0 ${padding}px;
              font-weight: 600;
              font-size: 14px;
              color: hsl(240 50% 55% / 1);
            `}
          >
            MOUSE DEVICE
          </div>
          {/* Animated elementsss~!!! */}
          <div
            css={`
              position: absolute;
              top: 222px;
              left: ${padding + 18}px;
              width: 100%;
              transform: ${this.transformAnimatedContainerCalc};
              transition: transform ${this.animationMs}ms ease-out;
              /* height: 150px; */
            `}
          >
            <svg
              id="route"
              viewBox="50 150 600 600"
              css={`
                position: absolute;
                top: -54px;
                left: -199px;
                width: 100%;
              `}
            >
              <path
                id="infinite-path"
                d="M 380 260 C 380 360 240 360 240 260 C 240 160 380 160 380 260 C 380 360 520 360 520 260 C 520 160 380 160 380 260"
                fill="none"
              />
              <MouseCursor
                animationStep={animationStep}
                animationMs={this.animationMs}
              />
            </svg>
            <img
              src={clickSparks}
              alt="clickSparks"
              css={`
                position: relative;
                top: -40px;
                left: -35px;
                opacity: ${animationStep === 0 || animationStep === 6 ? 1 : 0};
                transition: opacity ${this.animationMs * 1.3}ms ease-out;
              `}
            />
            {animationStep >= 3 ? (
              <ClickSparksAnimated animationMs={this.animationMs} />
            ) : null}
          </div>
          <div
            css={`
              margin-top: 190px;
              line-height: 122%;
              padding: ${padding}px;
            `}
          >
            <div
              css={`
                margin: 0 0 8px;
                font-size: 21px;
                font-weight: 600;
                color: hsl(240 10% 35% / 1);
              `}
            >
              Bring a Mouse
            </div>
            <div
              css={`
                line-height: 133.5%;
                font-size: 18px;
                color: hsl(240 10% 60% / 1);
              `}
            >
              CoreText has 100% keyboard shortcut coverage, but it's not
              exclusive to heavy keyboard users. Use your mouse as you normally
              would.
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    // GSAP requires we init elements
    this.initMouseCursor();
  }

  startAnimation = () => {
    this.timers[0] = setTimeout(() => {
      // fade away static sparks
      this.setState({ animationStep: 1 });
      this.timers[1] = setTimeout(() => {
        // move cursor to position
        this.setState({ animationStep: 2 });
        this.timers[2] = setTimeout(() => {
          // clickity! clickity!
          this.setState({ animationStep: 3 });
          this.timers[3] = setTimeout(() => {
            // animation the mouse cursor along the path of an infinity symbol
            this.setState({ animationStep: 4 }, this.animateTheInfinityPath);
            this.timers[4] = setTimeout(() => {
              // animate mouse cursor back to initial position
              this.setState({ animationStep: 5 });
              this.timers[5] = setTimeout(() => {
                // re-show the static sparks
                this.setState({ animationStep: 6 });
              }, this.animationMs);
            }, this.animationMs * 7);
          }, this.animationMs * 4);
        }, this.animationMs);
      }, this.animationMs);
    }, this.animationMs * 2);
  };

  resetAnimation = () => {
    this.timers.forEach((timer) => {
      clearTimeout(timer);
    });
    this.gsapMouseCursor.seek(0).pause();
    this.setState(this.initialState);
  };

  pauseSparking = () => {
    const x = document.querySelectorAll("[class*='spark_ ']");

    x.forEach((y) => {
      y.style.animationPlayState = "paused";
    });
  };

  initMouseCursor = () => {
    gsap.set("#mouse-cursor", { scaleX: -1, scale: 1 });
    this.defineAnimationPath();
  };

  defineAnimationPath = () => {
    this.gsapMouseCursor = gsap
      .timeline({ repeat: 0 })
      .from("#mouse-cursor", {
        motionPath: {
          path: "#infinite-path",
          align: "#infinite-path",
          alignOrigin: [0.5, 0.5],
          // autoRotate: true,
        },
        duration: 1.5,
        ease: "ease-in",
      })
      .pause();
  };

  animateTheInfinityPath = () => {
    this.gsapMouseCursor.seek(0).play();
  };

  transformAnimatedContainerCalc = () => {
    const { animationStep } = this.state;

    if (animationStep === 2 || animationStep === 3 || animationStep === 4)
    {
      return "translate(28%,-95%)";
    } else if (
      animationStep === 0 ||
      animationStep === 1 ||
      animationStep >= 5
    )
    {
      return "translate(0%, 0%)";
    }
  };
}
